<template>
    <div>
        <div class="d-flex align-items-center justify-content-between mb16">
            <Icon v-if="isMobile" name="arrow-left" class="pointer" @click="close" />
            <h4 class="text-black neue fw-medium mb-0 lh28 fsp20" :class="{ 'flex-grow-1 text-center': isMobile }">{{ content.text }}</h4>
            <Icon v-if="!isMobile" name="close" class="pointer" @click="close" />
        </div>
        <div class="bg-white rounded12" :class="{ 'p24': !isMobile }">
            <div class="d-flex flex-column gap8 mb24">
                <span class="fsp14 neue-roman primary-grey">{{ $t('components.service.modal.Template.1') }}</span>
                <InputSimple
                    id="template_name"
                    class="w-100"
                    :dataValue="this.new_name"
                    @updateParentState="updateState"
                    @onEnter="submit"
                />
            </div>
            <div class="d-flex gap16 h48">
                <Button :name="$t('components.service.modal.Rename.2')" class="flex-grow-1 fsp14" type="btn-warning" :disabled="!new_name || !new_name.trim()" @click="submit" />
                <Button :name="$t('components.service.modal.Rename.3')" class="flex-grow-1 fsp14" type="btn-outline-grey" @click="close" />
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/service/Button';
import InputSimple from '@/components/service/InputSimple';
import Icon from '@/components/icons/Icon';

export default {
    components: {
        Button,
        InputSimple,
        Icon
    },
    props: {
        close: [Function],
    },
    data() {
        return {
            content: this.$store.state.modal.content,
            new_name: this.$store.state.modal.content.name,
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        }
    },
    methods: {
        updateState(state) {
            this.new_name = state.value;
        },
        submit() {
            if (!this.new_name || !this.new_name.trim()) return;
            this.$store.commit('MODAL', {
                action: false,
                type: false,
                content: false
            });
            this.$store.commit('DARK_WRAPPER', false);
            this.content.callback(this.new_name);
        }
    },
}
</script>

